var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.coursePurchase
    ? _c("div", { staticClass: "d-flex cursor-pointer" }, [
        _c(
          "div",
          {},
          [
            _c("v-img", {
              attrs: {
                "min-height": "100",
                "min-width": "100",
                "max-height": "100",
                "max-width": "100",
                src: _vm.coursePurchase.courseUrl,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ms-7" }, [
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _vm.coursePurchase.isStoped
                ? _c(
                    "v-chip",
                    {
                      staticClass: "text-white",
                      attrs: { color: "red", small: "", label: "" },
                    },
                    [_vm._v("\n        終了\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.coursePurchase.isDone
                ? _c(
                    "v-chip",
                    {
                      staticClass: "text-white",
                      attrs: { color: "green", small: "", label: "" },
                    },
                    [_vm._v("\n        アクティブ\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.coursePurchase.isPending
                ? _c(
                    "v-chip",
                    {
                      staticClass: "text-white",
                      attrs: { color: "red", small: "", label: "" },
                    },
                    [_vm._v("\n        未払い\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "text-blue ms-2 font-bold" }, [
                _vm._v(_vm._s(_vm.coursePurchase.courseName)),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "mt-2 text-gray white-space-pre-line",
            domProps: {
              innerHTML: _vm._s(_vm.coursePurchase.courseDescription),
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-2 font-bold" },
            [
              _vm.coursePurchase.hasInstallment
                ? [
                    _vm._v(
                      "\n        分割払い（" +
                        _vm._s(_vm.coursePurchase.installmentCountCurrent) +
                        " / " +
                        _vm._s(_vm.coursePurchase.installmentCountTotal) +
                        "）\n        " +
                        _vm._s(
                          _vm.coursePurchase.paiedPrice
                            ? _vm.coursePurchase.paiedPrice.toLocaleString()
                            : 0
                        ) +
                        "円 "
                    ),
                    _vm.coursePurchase.nextPay
                      ? _c("span", [
                          _vm._v(
                            "次回 " +
                              _vm._s(_vm.dateFormat(_vm.coursePurchase.nextPay))
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.coursePurchase.hasInstallment
                ? [
                    _vm._v(
                      "\n        一括購入\n        " +
                        _vm._s(
                          _vm.coursePurchase.paiedPrice
                            ? _vm.coursePurchase.paiedPrice.toLocaleString()
                            : 0
                        ) +
                        "円\n      "
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }